import { Marketplace } from "./marketplace.feature";

export default Marketplace;
